module.exports = __webpack_public_path__ + "assets/actor.7217378d.svg";